import {
	Box,
	Button,
	Card,
	CardContent,
	Chip,
	Collapse,
	Divider,
	Grid,
	Radio,
	Stack,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import { formatAge } from '@/utils/ageHelper';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DISPLAY_DATE_FORMAT } from '@/utils/dateHelper';
import dayjs from 'dayjs';
import {
	useDeleteDsm5AdultMutation,
	useGetDsm5AdultDetailQuery,
} from '@/api/forms-management/dsm5Adult';
import LogHistory from '../LogHistory';
import FormManagementChip from '@/common/components/FormManagementChip';
import ConfirmationDialog from '@/common/components/ConfirmationDialog/ConfirmationDialog';
import useModal from '@/common/components/ConfirmationDialog/useModal';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import LocalDataGrid from '@/common/components/dataGrid/LocalDataGrid';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	useGetDsmFiveAdultGenerateReportMutation,
	useGetExportCustomerPDFMutation,
} from '@/api/common';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export interface DataGrid {
	updatedAt: string;
	createdAt: string;
}
export default function Dsm5AdultDetailPage() {
	const { t } = useTranslation();
	const { preAdmissionId, dsm5AdultId, admissionRequestId } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const memberListType = location.pathname.includes('admission-request-list')
		? 'admission-request-list'
		: 'member-list';
	const [deleteDsm5Adult] = useDeleteDsm5AdultMutation();
	const showModal = useModal();

	const [getExportCustomerPDF] = useGetExportCustomerPDFMutation();
	const [getDsmFiveAdultGenerateReport] =
		useGetDsmFiveAdultGenerateReportMutation();

	const [tableExpanded, setTableExpanded] = useState(true);

	const [answerList, setAnswerList] = useState([
		{
			id: 1,
			group: 'I',
			title: t(`preAdmission.troubledProblemsTitle1`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 2,
			group: 'I',
			title: t(`preAdmission.troubledProblemsTitle2`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 3,
			group: 'II',
			title: t(`preAdmission.troubledProblemsTitle3`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 4,
			group: 'III',
			title: t(`preAdmission.troubledProblemsTitle4`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 5,
			group: 'III',
			title: t(`preAdmission.troubledProblemsTitle5`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 6,
			group: 'IV',
			title: t(`preAdmission.troubledProblemsTitle6`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 7,
			group: 'IV',
			title: t(`preAdmission.troubledProblemsTitle7`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 8,
			group: 'IV',
			title: t(`preAdmission.troubledProblemsTitle8`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 9,
			group: 'V',
			title: t(`preAdmission.troubledProblemsTitle9`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 10,
			group: 'V',
			title: t(`preAdmission.troubledProblemsTitle10`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 11,
			group: 'VI',
			title: t(`preAdmission.troubledProblemsTitle11`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 12,
			group: 'VII',
			title: t(`preAdmission.troubledProblemsTitle12`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 13,
			group: 'VII',
			title: t(`preAdmission.troubledProblemsTitle13`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 14,
			group: 'VIII',
			title: t(`preAdmission.troubledProblemsTitle14`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 15,
			group: 'IX',
			title: t(`preAdmission.troubledProblemsTitle15`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 16,
			group: 'X',
			title: t(`preAdmission.troubledProblemsTitle16`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 17,
			group: 'X',
			title: t(`preAdmission.troubledProblemsTitle17`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 18,
			group: 'XI',
			title: t(`preAdmission.troubledProblemsTitle18`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 19,
			group: 'XII',
			title: t(`preAdmission.troubledProblemsTitle19`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 20,
			group: 'XII',
			title: t(`preAdmission.troubledProblemsTitle20`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 21,
			group: 'XIII',
			title: t(`preAdmission.troubledProblemsTitle21`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 22,
			group: 'XIII',
			title: t(`preAdmission.troubledProblemsTitle22`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
		{
			id: 23,
			group: 'XIII',
			title: t(`preAdmission.troubledProblemsTitle23`),
			answer0: false,
			answer1: false,
			answer2: false,
			answer3: false,
			answer4: false,
		},
	]);

	const { data: details }: any = useGetDsm5AdultDetailQuery(dsm5AdultId || '', {
		refetchOnMountOrArgChange: true,
	});

	useEffect(() => {
		if (details) {
			const restoredList = answerList.map((item: any, index: number) => {
				const row: any = {
					...item,
					answer0: false,
					answer1: false,
					answer2: false,
					answer3: false,
					answer4: false,
				};
				if (item.group == 'I') row.maxScore = details.data['maxScore1'];
				if (item.group == 'II') row.maxScore = details.data['maxScore2'];
				if (item.group == 'III') row.maxScore = details.data['maxScore3'];
				if (item.group == 'IV') row.maxScore = details.data['maxScore4'];
				if (item.group == 'V') row.maxScore = details.data['maxScore5'];
				if (item.group == 'VI') row.maxScore = details.data['maxScore6'];
				if (item.group == 'VII') row.maxScore = details.data['maxScore7'];
				if (item.group == 'VIII') row.maxScore = details.data['maxScore8'];
				if (item.group == 'IX') row.maxScore = details.data['maxScore9'];
				if (item.group == 'X') row.maxScore = details.data['maxScore10'];
				if (item.group == 'XI') row.maxScore = details.data['maxScore11'];
				if (item.group == 'XII') row.maxScore = details.data['maxScore12'];
				if (item.group == 'XIII') row.maxScore = details.data['maxScore13'];

				row[`answer${details.data.answerList[index]}`] = true;
				console.log(row);
				return row;
			});
			setAnswerList(restoredList);
		}
	}, [details]);

	const columns: GridColDef[] = [
		{
			field: 'group',
			headerName: '',
			flex: 1,
		},
		{
			field: 'title',
			headerName: t('preAdmission.troubledProblemsTitle'),
			flex: 30,
		},
		{
			field: 'answer0',
			headerName: t('preAdmission.scoreOther1'),
			flex: 10,
			renderCell: (params: any) => radioRenderCell(params, 0),
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.title}-${row.answer1}` : value;
			},
		},
		{
			field: 'answer1',
			headerName: t('preAdmission.scoreOther2'),
			flex: 10,
			renderCell: (params: any) => radioRenderCell(params, 1),
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.title}-${row.answer1}` : value;
			},
		},
		{
			field: 'answer2',
			headerName: t('preAdmission.scoreOther3'),
			flex: 10,
			renderCell: (params: any) => radioRenderCell(params, 2),
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.title}-${row.answer1}` : value;
			},
		},
		{
			field: 'answer3',
			headerName: t('preAdmission.scoreOther4'),
			flex: 10,
			renderCell: (params: any) => radioRenderCell(params, 3),
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.title}-${row.answer1}` : value;
			},
		},
		{
			field: 'answer4',
			headerName: t('preAdmission.scoreOther5'),
			flex: 10,
			renderCell: (params: any) => radioRenderCell(params, 4),
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.title}-${row.answer1}` : value;
			},
		},
		{
			field: 'maxScore',
			headerName: t('preAdmission.maxScore'),
			flex: 10,
			rowSpanValueGetter: (value, row) => {
				return row ? `${row.group}` : value;
			},
		},
	];

	const radioRenderCell = (params: any, score: number) => {
		const { id, row, api } = params;

		const isChecked = row[`answer${score}`] === true;
		return <Radio checked={isChecked} value={score} disabled={true} />;
	};

	const handleDelete = async () => {
		showModal((props: any) => (
			<ConfirmationDialog
				{...props}
				showCloseIcon={false}
				title={t('preAdmission.deleteConfirmation')}
				titleProps={{ variant: 'h6' }}
				description={
					<Typography variant='body1'>
						{t('preAdmission.isDeleteForm', {
							formName: t('preAdmission.dsm5Adult'),
						})}
					</Typography>
				}
				cancellationText={t('button.cancel')}
				confirmationText={t('button.confirm')}
				confirmationButtonProps={{ type: 'submit', variant: 'contained' }}
				onConfirm={async () => {
					const response = await deleteDsm5Adult(details?.data.id || '');
					if ('data' in response) {
						enqueueSnackbar(t('snackbar.enquiryRecordDeleteSuccess'), {
							variant: 'warning',
							anchorOrigin: { horizontal: 'center', vertical: 'top' },
							autoHideDuration: 3000,
							action: (key) => {
								return <CloseIcon onClick={() => closeSnackbar(key)} />;
							},
						});
						navigate(
							preAdmissionId
								? `/pre-admission/pre-admission-list/detail/${preAdmissionId}/forms-management`
								: `/member-management/${memberListType}/detail/${admissionRequestId}/forms-management`,
							{ replace: true }
						);
					}
				}}
			/>
		));
	};

	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box display='flex' justifyContent='space-between'>
					<Typography variant='h4'>
						{t('drawerListItems.dsm5AdultDetail')}
						<FormManagementChip
							sx={{ marginLeft: '10px' }}
							status={details?.data.formStatus}
							label={details?.data.formStatusDesc}
						/>
					</Typography>
					<Box>
						<Button
							endIcon={<FileDownloadOutlinedIcon />}
							onClick={async () => {
								const response = await getDsmFiveAdultGenerateReport(
									details?.data.id
								);
								if ('data' in response) {
									getExportCustomerPDF(response?.data?.data.url);
								}
							}}
							variant='contained'
							sx={{ marginRight: '24px' }}
						>
							{t('button.exportAsPdf')}
						</Button>
						<Button
							endIcon={<DeleteOutlinedIcon />}
							onClick={() => handleDelete()}
							variant='contained'
						>
							{t('button.delete')}
						</Button>
					</Box>
				</Box>

				<Card sx={{ padding: '24px 24px', marginTop: 3 }}>
					<Grid container spacing={3} marginTop={0}>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.en_name_en')}
								value={details?.data.nameEn}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.zh_name_en')}
								value={details?.data.nameZh}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.zh_age')}
								value={formatAge(
									details?.data.currentAge,
									details?.data.currentAgeEstimated,
									'zh'
								)}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.zh_sex')}
								value={details?.data.sexDesc}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.signatureDate')}
								value={
									details?.data.fillingDate
										? dayjs(details?.data.fillingDate)
												.locale('en')
												.format(DISPLAY_DATE_FORMAT)
										: ''
								}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.zh_relationship')}
								value={details?.data.relationship}
							/>
						</Grid>
						<Grid size={6}>
							<AppFieldView
								label={t('preAdmission.spentTime')}
								value={details?.data.spentTime}
							/>
						</Grid>
					</Grid>

					<Divider sx={{ margin: '24px 0' }} />
					<Box
						display='flex'
						justifyContent='space-between'
						onClick={() => setTableExpanded(!tableExpanded)}
					>
						<Typography
							variant='h6'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.questionnaireTitle')}
						</Typography>
						<ExpandMoreIcon
							sx={{
								transform: tableExpanded ? 'rotate(180deg)' : 'none',
							}}
						/>
					</Box>

					<Collapse in={tableExpanded}>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.Dsm5AdultTips')}
						</Typography>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={12} display='flex'>
								<LocalDataGrid
									rows={answerList}
									columns={columns}
									getRowId={(row) => row.id}
									pagination={false}
									rowSpanning={true}
								/>
							</Grid>
						</Grid>
					</Collapse>
				</Card>

				{details?.data.id && (
					<Card sx={{ margin: '24px 0' }}>
						<CardContent>
							<LogHistory formId={details.data.id} />
						</CardContent>
					</Card>
				)}
			</Box>
		</>
	);
}
